import {useAtomValue, useSetAtom} from 'jotai';
import {WifiOff, X} from 'lucide-react';
import {offlineModeAtom, offlineBannerHiddenAtom} from '@lib/atoms';
import {Button} from '@ui/shadcn/button';

/** Красно-оранжевый баннер сверху страницы при включённом demo-офлайн режиме (раунд 16 §3). */
export const OfflineBanner = () => {
  const offline = useAtomValue(offlineModeAtom);
  const hidden = useAtomValue(offlineBannerHiddenAtom);
  const setHidden = useSetAtom(offlineBannerHiddenAtom);

  if (!offline || hidden) return null;

  return (
    <div
      className='flex items-center gap-2.5 px-4 py-2 border-b border-[#fca5a5]'
      style={{backgroundColor: '#fef2f2'}}
      role='alert'
    >
      <WifiOff size={14} className='text-[#dc2626] shrink-0' />
      <p className='flex-1 text-xs text-[#7f1d1d] leading-snug'>
        Нет подключения к интернету. Данные могут быть устаревшими.
      </p>
      <Button
        type='button'
        variant='ghost'
        size='icon-xs'
        onClick={() => setHidden(true)}
        aria-label='Скрыть баннер'
        className='text-[#dc2626] hover:bg-[#fee2e2] hover:text-[#dc2626]'
      >
        <X size={13} />
      </Button>
    </div>
  );
};
